import { useCallback, useEffect } from 'react';

import { useNotificationMarkAsOld, type Notification } from '@/entities/notification';

import { isNotificationUrgent } from '../../../lib/is-notification-urgent';
import { useNotificationsCtx } from '../../context';

interface MarkAsOldProps {
  /**
   * Disable auto-marking notifications as not new
   * @default false
   */
  disabled?: boolean;
}

const MarkAsOld = ({ disabled }: MarkAsOldProps) => {
  const [markAsOld] = useNotificationMarkAsOld();

  const {
    allNotifications,
    drawer: { isOpen },
    notificationType
  } = useNotificationsCtx();

  const urgentNotificationsOpen = isOpen && notificationType === 'urgent';

  const markAllAsOld = useCallback(
    async (notifications: Notification[]) => {
      const ids = notifications.map(notification => notification.id);

      markAsOld(ids);
    },
    [markAsOld]
  );

  useEffect(() => {
    if (disabled || !urgentNotificationsOpen) return;

    const urgentNotifications = allNotifications.filter(isNotificationUrgent);

    if (urgentNotifications.length) {
      markAllAsOld(urgentNotifications);
    }
  }, [allNotifications, disabled, markAllAsOld, urgentNotificationsOpen]);

  return null;
};

export default MarkAsOld;
